var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckGreen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57555 7.99991C4.39155 7.99991 4.21555 7.92391 4.08955 7.78991L0.847547 4.33725C0.594881 4.06925 0.608881 3.64725 0.876881 3.39525C1.14555 3.14325 1.56755 3.15658 1.81888 3.42458L4.56888 6.35191L10.1742 0.217246C10.4235 -0.0554209 10.8449 -0.0734209 11.1169 0.174579C11.3882 0.422579 11.4069 0.844579 11.1589 1.11591L5.06755 7.78258C4.94288 7.91991 4.76555 7.99858 4.58021 7.99991H4.57555Z",
    fill: "#0EC06B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGreen2);
export default __webpack_public_path__ + "static/media/IconCheckGreen2.52344612.svg";
export { ForwardRef as ReactComponent };